export default __webpack_public_path__ + "static/media/person_1@3x.c95b2108.png";